import { z } from 'zod';

import { ViewMode } from '../../-constant';

export const SearchSchema = z.object({
  // 基準日（YYYY-MM-DD形式）
  baseDate: z.string().optional(),

  // 表示モード
  viewMode: z
    .union([
      z.enum([ViewMode.HIERARCHY, ViewMode.TREE, ViewMode.TABLE]),
      z.literal('').transform(() => ViewMode.HIERARCHY),
    ])
    .optional()
    .default(ViewMode.HIERARCHY),

  // コンパクト表示（ツリー型選択時のみ有効）
  isCompactView: z.boolean().optional().default(false),

  // 検索クエリ（組織ユニット名・コードで絞り込み）
  q: z.string().optional(),

  // 詳細画面から戻ったときに中央表示するノード ID
  focusedNodeId: z.string().optional(),
});

export type SearchParams = z.infer<typeof SearchSchema>;
